/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Title_2Inputs */

const en_services_title_2 = /** @type {(inputs: Services_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make money.`)
};

const lv_services_title_2 = /** @type {(inputs: Services_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelniet vairāk.`)
};

/**
* | output |
* | --- |
* | "Make money." |
*
* @param {Services_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_title_2 = /** @type {((inputs?: Services_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_title_2(inputs)
	return en_services_title_2(inputs)
});